// The mapping between the account statuses received from the Backend and their corresponding names to be displayed
export const ACCOUNT_STATUS_DISPLAY_NAMES = {
    PENDING: "Pending",
    ACTIVE: "Active",
    DELETED: "Deleted",
}

// The name of the quota property that stores the limit of the max number of page requests per user
export const MAX_REQUESTS_KEY = "maxRequests"
